import DestinationPreview from "../Previews/DestinationPreview/DestinationPreview";

export const home = {
    form: [
        {
            title: "Page Name",
            key: "page_name",
            className: "col-lg-12",
            type: "input",
            required: false,
        },
        {
            title: "Meta Description",
            key: "meta_description",
            className: "col-lg-12",
            type: "input",
            required: false,
        },
    ],
    component: [
        {
            type: 1,
            fields: [
                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                },
                
                {
                    title: "English Description",
                    key: "description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Simplified Chinese Description",
                    key: "simplified_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Traditional Chinese Description",
                    key: "traditional_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Bahasa Description",
                    key: "bahasa_description",
                    className: "col-lg-3",
                    type: "html",
                },
               
                {
                    title: "Page Video",
                    key: "image",
                    filetype: "video",
                    className: "col-lg-12",
                    placeholder: "Upload Page Video",
                    type: "file",
                    required: false,
                },
                {
                    title: "Simplified Chinese Video",
                    key: "simplified_chinese_image",
                    filetype: "video",
                    className: "col-lg-12",
                    placeholder: "Upload Page Video",
                    type: "file",
                    required: false,
                },
                {
                    title: "Traditional Chinese Video",
                    key: "traditional_chinese_image",
                    filetype: "video",
                    className: "col-lg-12",
                    placeholder: "Upload Page Video",
                    type: "file",
                    required: false,
                },
                {
                    title: "Bahasa Video",
                    key: "bahasa_image",
                    filetype: "video",
                    className: "col-lg-12",
                    placeholder: "Upload Page Video",
                    type: "file",
                },

            ],
            preview: (activetab, cardData) => (
                <DestinationPreview activetab={activetab} cardData={cardData} />
            ),
        },

    ],
};
